import React from "react";

import { StaticImage } from "gatsby-plugin-image";

//components
import Accordion from "./Accordion";

//styles
import * as styles from "./Inclusion.module.css";
import { Link } from "gatsby";

const Inclusion = props => {
  return (
    <div className="bgLightgray">
      <div className={`container twinContainer ${styles.marginCo}`}>
        <div className="row">
          <div className="col-12 col-md-12 col-lg-12">
            <p className={`gradientText ${styles.paddingBo}`}>
              Program Inclusions
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-9 col-md-9 col-lg-9">
            <p className={styles.content}>WBDT™ and Compassionate Care team</p>
          </div>
        </div>
        <div className="row">
          <div className={`col-md-12`}>
            <Accordion />
          </div>
        </div>
        {!props.twinRead ? (
          <div className={`row ${styles.extraRead}`}>
            <div
              className={`col-12 ${
                props.modal ? "col-md-12 col-lg-12" : "col-md-6 col-lg-6"
              }`}
            >
              <Link className={"navLink"} to="/reversal-vs-management">
                <div className="row align-items-center">
                  <div className="col-2 col-lg-2 col-md-2">
                    <p className={styles.readText}> 5 min Read</p>
                  </div>
                  <div className="col-4 col-lg-4  px-md-4 col-md-4 mb-1">
                    <StaticImage
                      src="../../../images/5_min_readImg.png"
                      alt="read"
                      placeholder="blurred"
                    />
                  </div>
                  <div className="col-6 col-lg-6 col-md-6 ">
                    <div className="row align-items-center">
                      <div className="col-12 px-md-4 px-3 col-lg-12 col-md-12">
                        <h3 className={styles.readContent}>
                          Why is Twin unique, specifically why is it different
                          from others?
                        </h3>
                      </div>
                      <div className="col-12 px-md-4 px-3 col-lg-12 col-md-12">
                        <p className={styles.readText1}>June 1, 2021 </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
              <hr className="mt-4" />
            </div>
          </div>
        ) : (
          <div className="pb-5"></div>
        )}
      </div>
    </div>
  );
};

export default Inclusion;
